// extracted by mini-css-extract-plugin
export default {"content":"styles_content__MdQwF","modal":"styles_modal__bfhNu"};